import { render, staticRenderFns } from "./search.component.vue?vue&type=template&id=4049e2d5&scoped=true&lang=pug"
import script from "./search.component.vue?vue&type=script&lang=ts"
export * from "./search.component.vue?vue&type=script&lang=ts"
import style0 from "./search.component.vue?vue&type=style&index=0&id=4049e2d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4049e2d5",
  null
  
)

export default component.exports